import { Component }from '@angular/core';

@Component({
  selector: 'app-banner-reason',
  templateUrl: './banner-reason.component.html',
  styleUrls: ['./banner-reason.component.scss'],
  standalone: true
})
export class BannerReasonComponent {
}
